import { lazyTool } from "../lazy";
import type { ToolDefinition } from "../types";

export const imageTools: ToolDefinition[] = [
  {
    id: "image-converter",
    name: "Image Converter",
    description: "Convert images between PNG, JPEG, WebP, and AVIF when the browser supports it.",
    category: "image",
    keywords: ["image", "convert", "png", "jpeg", "jpg", "webp", "avif", "transcode"],
    component: lazyTool(() => import("./image-converter")),
  },
  {
    id: "image-compressor",
    name: "Image Compressor",
    description: "Shrink images with quality and dimension limits, then compare file sizes.",
    category: "image",
    keywords: ["image", "compress", "optimize", "quality", "size", "shrink", "webp", "jpeg"],
    component: lazyTool(() => import("./image-compressor")),
  },
  {
    id: "image-resizer",
    name: "Image Resizer",
    description: "Resize images by pixels or percentage with aspect lock, presets, and format choice.",
    category: "image",
    keywords: ["image", "resize", "scale", "dimensions", "width", "height", "aspect ratio"],
    component: lazyTool(() => import("./image-resizer")),
  },
  {
    id: "image-cropper",
    name: "Image Cropper",
    description: "Drag a crop rectangle over an image, adjust exact pixel bounds, and export the crop.",
    category: "image",
    keywords: ["image", "crop", "trim", "cut", "aspect ratio", "rectangle", "canvas"],
    component: lazyTool(() => import("./image-cropper")),
  },
  {
    id: "svg-optimizer",
    name: "SVG Optimizer",
    description: "Remove comments, metadata, editor namespaces, and redundant whitespace from SVG files.",
    category: "image",
    keywords: ["svg", "optimize", "minify", "cleanup", "inkscape", "metadata", "whitespace"],
    component: lazyTool(() => import("./svg-optimizer")),
  },
  {
    id: "favicon-generator",
    name: "Favicon Generator",
    description: "Generate 16 to 512 pixel PNG favicons and a multi-image favicon.ico from one image.",
    category: "image",
    keywords: ["favicon", "icon", "png", "ico", "apple touch icon", "16", "32", "512"],
    component: lazyTool(() => import("./favicon-generator")),
  },
  {
    id: "palette-extractor",
    name: "Palette Extractor",
    description: "Quantize an image into a dominant color palette with hex values and percentages.",
    category: "image",
    keywords: ["palette", "colors", "dominant", "extract", "quantize", "hex", "swatch"],
    component: lazyTool(() => import("./palette-extractor")),
  },
  {
    id: "exif-viewer",
    name: "EXIF Viewer",
    description: "Read JPEG EXIF metadata locally and download a metadata-stripped copy.",
    category: "image",
    keywords: ["exif", "metadata", "jpeg", "camera", "gps", "orientation", "strip"],
    component: lazyTool(() => import("./exif-viewer")),
  },
  {
    id: "placeholder-image",
    name: "Placeholder Image",
    description: "Render a custom size, color, and label placeholder image and download it.",
    category: "image",
    keywords: ["placeholder", "image", "mockup", "dummy", "label", "canvas", "solid color"],
    component: lazyTool(() => import("./placeholder-image")),
  },
  {
    id: "image-base64",
    name: "Image ↔ Base64",
    description: "Convert an image file to a data URL or Base64 and decode Base64 back to an image.",
    category: "image",
    keywords: ["image", "base64", "data url", "encode", "decode", "embed", "inline"],
    component: lazyTool(() => import("./image-base64")),
  },
];
